<template>
    <div v-if="currentExperimentalPlan.id">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="title has-text-left">
                        Experimental Plan
                        <b-tooltip :label="'This page is print-friendly. In most browsers you can also use the print dialog to export this as a PDF file.'"
                                   multilined
                                   type="is-dark"
                                   position="is-bottom" square>
                            <button class="button is-small no-print" style="border: 0px; background: none">
                                <span>
                                  <b-icon type="is-dark" pack="fas" icon="question-circle"></b-icon>
                                </span>
                            </button>
                        </b-tooltip>
                    </p>
                </div>
            </div>

            <div class="tile is-ancestor">
                <div class="tile has-text-left is-12 is-vertical is-parent">
                    <div class="tile is-child box">
                        <div class="columns is-mobile">
                            <div class="column is-one-quarter"><strong>Name:</strong></div>
                            <div class="column">{{currentExperimentalPlan.name}}</div>
                        </div>
                        <div class="columns is-mobile no-print">
                            <div class="column is-one-quarter"><strong>Status:</strong></div>
                            <div class="column">{{currentExperimentalPlan.status}}</div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="column is-one-quarter"><strong>Created on:</strong></div>
                            <div class="column ">
                                {{moment(currentExperimentalPlan.created_at).format("DD MMMM YYYY")}}
                            </div>
                        </div>

                    </div>

                    <div class="tile is-child box">
                        <!-- display analytical method -->
                        <b-collapse
                                aria-id="contentIdForA11y2"
                                class="panel no-print"
                                :open.sync="methodIsOpen">
                            <div
                                    slot="trigger"
                                    class="panel-heading"
                                    role="button"
                                    aria-controls="contentIdForA11y2">
                                <strong>Analytical Method</strong>

                                <span class="icon is-small is-pulled-right">
                                    <i class="fas fa-caret-down"></i>
                                </span>
                            </div>
                            <div class="panel-block  is-horizontal-center">
                                <view-method-feature class="fullWidth" :currentMethod="currentMethod"></view-method-feature>
                            </div>
                        </b-collapse>
                        <!-- display analytical method end -->

                        <!-- display template -->
                        <b-collapse
                                aria-id="contentIdForA11y2"
                                class="panel no-print"
                                :open.sync="templateIsOpen">
                            <div
                                    slot="trigger"
                                    class="panel-heading"
                                    role="button"
                                    aria-controls="contentIdForA11y2">
                                <strong>Validation Plan</strong>

                                <span class="icon is-small is-pulled-right">
                                    <i class="fas fa-caret-down"></i>
                                </span>
                            </div>
                            <div class="panel-block  is-horizontal-center">
                                <view-validation-plan-template-feature class="fullWidth" :assesmentMethods="assesmentMethods" :currentValidationPlanTemplate="currentValidationPlanTemplate" :validationParameters="validationParameters"></view-validation-plan-template-feature>
                            </div>
                        </b-collapse>

                        <div v-if="!generating" v-html="experimentPlanContent"></div>
                        <loading v-else></loading>

                        <plan-content-generator
                                ref="generator"
                                :experimentalPlanId="currentExperimentalPlan.id"
                                @planHtml="handlePlanContent"
                                @loadingState="handleContentLoadingState"
                        >
                        </plan-content-generator>
                    </div>



                    <div class="tile is-child no-print">
                        <!-- Action buttons -->
                        <span class="is-pulled-right">
                            <a v-if="currentExperimentalPlan.status != 'LOCKED'" class="button is-large is-primary" v-on:click="handleEditExperimentalPlan(currentExperimentalPlan)">
                                <span>Edit</span>
                            </a>
                            <span style="margin-left:20px"></span>
                            <a class="button is-large" @click="$router.go(-1)">
                                <span>Back</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>

        </div>
</template>

<script>

import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import ViewMethodFeature from "../../components/method/ViewMethodFeature";
import PlanContentGenerator from "./PlanContentGenerator";
import ViewValidationPlanTemplateFeature from "../../components/template/ViewValidationPlanTemplateFeature";
import Loading from "../../valchrom/common/Loading";

export default {
    name: 'ViewExperimentalPlan',
    components: {ViewMethodFeature, ViewValidationPlanTemplateFeature, PlanContentGenerator,
        Loading},
    data: function () {
        return {
            methodIsOpen: false,
            templateIsOpen: false,
            component_url: 'experiments/plans/',
            currentExperimentalPlan: {},
            currentMethod: {},
            currentValidationPlanTemplate: {},
            assesmentMethods: [],
            currentOptimizedPlan: null,
            experimentPlanContent: null,//null when re-generating
            generatorLoading: false,
            moment: require('moment')
        }
    },

    computed: {
        ...mapGetters ([
            'base_url','currentExpPlanID', 'auth_header', 'validationParameters'
        ]),
        generating(){
            return this.experimentPlanContent == null && this.generatorLoading;
        }
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXP_PLAN_ID'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        setExpPlanId: function(){
            this.CHANGE_EXP_PLAN_ID(this.currentExperimentalPlan.id)
        },
        getCurrentValidationPlanTemplate: function() {
            axios
                .get(this.base_url+ "experiments/templates/" + this.currentExperimentalPlan.template.id, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.currentValidationPlanTemplate = response.data;
                    console.log("currentValidationPlanTemplate ", this.currentValidationPlanTemplate)

                    this.currentValidationPlanTemplate.assessment_methods_objects = []

                    var mainThis = this
                    response.data.assessment_methods.forEach(function(method, i, array) {
                        mainThis.getAssesmentMethod(method, response.data)
                    })
                })
                .catch(error => {
                    console.log("Something went wrong getting the ValidationPlanTemplates :(", error);
                });
        },
        getAssesmentMethod: function(method, currentValidationPlanTemplate){
            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    meth.criteria =[]
                    var mainThis = this
                    currentValidationPlanTemplate.criteria.forEach(function(item, index, array) {
                        if(item.assessment_method===meth.code_name){
                            meth.criteria.push(item)
                        }
                    })
                    this.currentValidationPlanTemplate.assessment_methods_objects.push(meth)
                    this.assesmentMethods.push(meth)
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },
        getCurrentMethod: function() {
            axios
                .get(this.base_url+ "experiments/methods/" + this.currentExperimentalPlan.method.id, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.currentMethod = response.data
                    console.log("currentMethod", this.currentMethod)
                })
                .catch(error => {
                    console.log("Something went wrong getting the methods :(", error);
                })
        },
        getExperimentalPlan: function(){
            console.log("GET experimental plan",this.base_url+this.component_url +
                this.currentExperimentalPlan.id)
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentExperimentalPlan.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalPlan = response.data;
                    this.experimentPlanContent = response.data.content;
                    console.log("received plan")
                    this.getCurrentValidationPlanTemplate()
                    this.getCurrentMethod()
                })
                .catch(error => {
                    console.log("Something went wrong getting the current Experimental Plan", error);
                });
        },
        handleEditExperimentalPlan: function(currentExperimentalPlan) {
            console.log("handleEditExperimentalPlan: currExperimentalPlan is ", currentExperimentalPlan.name)
            this.$router.push({ name: "EditExperimentalPlan", params: { id: currentExperimentalPlan.id } });
        },
        handlePlanContent(content){
            console.log("handlePlanContent",content.substr(0,30));
            if(this.experimentPlanContent == null){
                this.experimentPlanContent = content;
            }
        },
        handleContentLoadingState(contentLoadingState){
            console.log("handleContentLoadingState",contentLoadingState);
            this.generatorLoading = contentLoadingState;
        }
    },
    mounted () { 
        this.setBreadcrumb()
        if (this.$route.params.id) {
            this.currentExperimentalPlan.id = this.$route.params.id;                 
        }
        else {
            console.log("ExperimentalPlan view no router params.id")
            this.currentExperimentalPlan.id = this.currentExpPlanID    
        }               
        this.setExpPlanId()
        this.getExperimentalPlan()

        axios
        .get(
            this.base_url+ 'experiments/plans/'+this.currentExperimentalPlan.id+'/experiment_plan',
            {
                headers: this.auth_header
            }
        )
        .then(response => {
            console.log("Optimised experiment plan",response.data)
            this.currentOptimizedPlan = response.data;
        })
    }
}
</script>

